// extracted by mini-css-extract-plugin
export var statItem = "_c8-1";
export var statsRow = "_c8-0";